<template>
  <v-row v-if="reRenderComponent">
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="users"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('logs.search.form.user')"
        v-model="form.userId"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="logTypes"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('logs.search.form.log-type')"
        v-model="form.logTypeCode"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="actionTypes"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('logs.search.form.action-type')"
        v-model="form.actionTypeCode"
      ></v-autocomplete>
    </v-col>

    <v-col sm="6" md="4" cols="12" class="mb-3">
      <d-date-picker
        :label="$t('logs.search.form.from-date')"
        hide-details="auto"
        filled
        v-model="form.fromDate"
        :maxDate="maxFromDate"
      ></d-date-picker>
    </v-col>

    <v-col sm="6" md="4" cols="12" class="mb-3">
      <d-date-picker
        :label="$t('logs.search.form.to-date')"
        hide-details="auto"
        filled
        v-model="form.toDate"
        :maxDate="maxToDate"
        :minDate="form.fromDate"
      ></d-date-picker>
    </v-col>
  </v-row>
</template>
<script>
import { getLogSearchParams } from "@/services/log";
import { format, parseISO, compareAsc } from "date-fns";

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      form: null,
      users: [],
      logTypes: [],
      actionTypes: [],

      reRenderComponent: true,
    };
  },
  computed: {
    maxToDate() {
      return format(new Date(), "yyyy-MM-dd");
    },
    maxFromDate() {
      return this.form?.toDate
        ? format(parseISO(this.form?.toDate), "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd");
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    "form.fromDate": {
      handler(val) {
        if (
          this.form.toDate &&
          compareAsc(parseISO(val), parseISO(this.form.toDate)) == 1
        ) {
          this.form.toDate = null;

          this.reRenderComponent = false;
          this.$nextTick(() => {
            this.reRenderComponent = true;
          });
        }
      },
    },
    value: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
  async created() {
    const { logTypes, users, actionTypes } = await getLogSearchParams();
    this.logTypes = logTypes;
    this.users = users;
    this.actionTypes = actionTypes;
  },
};
</script>
